import axios from 'axios';
import { FirstQuestionnaireResponse } from '../../../interfaces/interfaceServices';
import { redirectTo } from '../navigationService';

const deleteToken = () => {
  localStorage.removeItem('accessToken');
  redirectTo('/');
};

export const sendRepechageQuestion = async (
  hash: string,
  respuestas: { id: string; pregunta: string; respuesta: string }[]
): Promise<FirstQuestionnaireResponse | undefined> => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/identity-validation-bff/v1.0.0/identity-validation/second-quest`;
  const token = localStorage.getItem('accessToken');

  if (!token) {
    console.error('Token no encontrado. Por favor, inicia sesión nuevamente.');
    redirectTo('/');
    throw new Error('No se encontró el token de acceso');
  }

  try {
    const response = await axios.post(
      apiUrl,
      { hash, respuestas },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'x-business': 'GASCO',
          'x-commerce': 'GASCO',
          'x-country': 'CL',
          'x-system': 'IdentityValidation',
          'x-user': 'GASCO_USER',
          'validatorChannel': 'GascoPass'
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(
        'Error al enviar las respuestas del cuestionario:',
        error.response ? error.response.data : error.message
      );

      const errorMessage = (error.response?.data || '')
        .toString()
        .trim()
        .toLowerCase();
      if (errorMessage === 'invalid token') {
        deleteToken();
      }
    } else {
      console.error('Error inesperado:', error);
    }
    throw error;
  }
};
